module.exports = __webpack_public_path__ + "img/vanuatu.bc5ecab2.png";